(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7695],{

/***/ 5378:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events",
      function () {
        return __webpack_require__(3015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _components_layout_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7821);
/* harmony import */ var _components_layout_content_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3301);
/* harmony import */ var _components_layout_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8038);
/* harmony import */ var _components_shared_preview_alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1698);





function Layout(param) {
    var preview = param.preview, siteNav = param.siteNav, topNav = param.topNav, topFooterNav = param.topFooterNav, bottomFooterNav = param.bottomFooterNav, siteSettings = param.siteSettings, asPath = param.asPath, contentComponents = param.contentComponents, view = param.view;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            preview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_shared_preview_alert__WEBPACK_IMPORTED_MODULE_4__/* .PreviewAlert */ .n, {
                asPath: asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_header__WEBPACK_IMPORTED_MODULE_1__/* .Header */ .h, {
                siteNav: siteNav,
                topNav: topNav,
                siteSettings: siteSettings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_content_components__WEBPACK_IMPORTED_MODULE_2__/* .ContentComponents */ .W, {
                contentComponents: contentComponents,
                view: view,
                layout: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_footer__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$, {
                siteSettings: siteSettings,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav
            })
        ]
    });
}


/***/ }),

/***/ 8668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);

function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "flex items-start justify-start mx-6 my-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "w-12 h-12 ease-linear border-4 border-t-4 border-gray-200 rounded-full loader"
        })
    });
}


/***/ }),

/***/ 3015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2918);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8107);
/* harmony import */ var _components_layout_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2029);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3304);
/* harmony import */ var _components_shared_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8668);









/**
 * Helper function to return the correct version of the document
 * If we're in preview mode, it'll return the preview document
 */ function filterDataToSingleItem(data, preview) {
    if (!Array.isArray(data)) {
        return data;
    }
    if (data.length === 1) {
        return data[0];
    }
    if (preview) {
        return data.find(function(item) {
            return item._id.startsWith("drafts.");
        }) || data[0];
    }
    return data[0];
}
var __N_SSG = true;
/**
 * The `usePreviewSubscription` takes care of updating
 * the preview content on the client-side
 */ function Page(param) {
    var data = param.data, preview = param.preview;
    var ref;
    var ref1;
    // const { asPath } = useRouter()
    var ref2 = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .usePreviewSubscription */ .$r)(data === null || data === void 0 ? void 0 : data.query, {
        params: (ref1 = data === null || data === void 0 ? void 0 : data.queryParams) !== null && ref1 !== void 0 ? ref1 : {},
        // The hook needs to know what we started with, to return it immediately
        // This is what it's important to fetch draft content server-side!
        initialData: data === null || data === void 0 ? void 0 : data.page,
        // The passed-down preview context determines whether this function does anything
        enabled: preview
    }), previewData = ref2.data;
    var page = filterDataToSingleItem(previewData, preview);
    // Notice the optional?.chaining conditionals wrapping every piece of content. This is extremely important as you can't ever rely on a single field of data existing when Editors are creating new documents. It'll be completely blank when they start!
    var superPage = (page === null || page === void 0 ? void 0 : page.superPages[0]) || null;
    var events = (page === null || page === void 0 ? void 0 : page.events) || [];
    var categories = (page === null || page === void 0 ? void 0 : page.categories) || [];
    var tags = (page === null || page === void 0 ? void 0 : page.tags) || [];
    // console.log({page})
    var view = {
        "events": (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(events),
        "categories": (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(categories),
        "tags": (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(tags)
    };
    var siteSettings = (page === null || page === void 0 ? void 0 : page.siteSettings) || null;
    var siteNav = (page === null || page === void 0 ? void 0 : page.siteNav) || null;
    var topNav = (page === null || page === void 0 ? void 0 : page.topNav) || null;
    var topFooterNav = (page === null || page === void 0 ? void 0 : page.topFooterNav) || null;
    var bottomFooterNav = (page === null || page === void 0 ? void 0 : page.bottomFooterNav) || null;
    var contentComponents = ((ref = page === null || page === void 0 ? void 0 : page.superPages[0]) === null || ref === void 0 ? void 0 : ref.contentComponents) || null;
    // console.log({contentComponents})
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (!router.isFallback && !(superPage === null || superPage === void 0 ? void 0 : superPage.slug)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            statusCode: 404
        });
    }
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_shared_loader__WEBPACK_IMPORTED_MODULE_7__/* .Loader */ .a, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_seo__WEBPACK_IMPORTED_MODULE_6__/* .SEO */ .H, {
                page: superPage,
                site: siteSettings,
                path: superPage === null || superPage === void 0 ? void 0 : superPage.slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_events__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                preview: preview,
                asPath: "events",
                siteNav: siteNav,
                topNav: topNav,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav,
                siteSettings: siteSettings,
                contentComponents: contentComponents,
                view: view
            })
        ]
    });
}


/***/ }),

/***/ 2918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6914,6556,7505,3090,8348,8857,9774,2888,179], function() { return __webpack_exec__(5378); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);